import { render, staticRenderFns } from "./ProviderViewGeneralTab.vue?vue&type=template&id=2d879944"
import script from "./ProviderViewGeneralTab.vue?vue&type=script&lang=js"
export * from "./ProviderViewGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports